import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FundingRoutingModule } from './funding-routing.module';
import { PageHeaderModule } from '../page-header/page-header.module';
import { PageFooterModule } from '../page-footer/page-footer.module';
import { ProgressModule } from '../progress/progress.module';

import { FundingComponent } from './funding.component';
import { LoadingModule } from '../loading/loading.module';

@NgModule({
    declarations: [
        FundingComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ProgressModule,
        FundingRoutingModule,
        PageHeaderModule,
        PageFooterModule,
        LoadingModule
    ]
})
export class FundingModule { }
